import {
  IconBread,
  IconBuildingChurch,
  IconClipboardList,
  IconHome,
  IconHourglassHigh,
  IconSettings,
  type Icon,
} from '@tabler/icons-react';
import type { TCapability } from '../auth/roles';
import { ROUTES } from './constants';

type NavigationItem = {
  id: number;
  name: string;
  icon: Icon;
  path: string;
  /** When set, the item is shown only to users holding this capability. */
  capability?: TCapability;
};

function NavItems(): NavigationItem[] {
  return [
    { id: 0, name: 'Home', icon: IconHome, path: ROUTES.LANDING },
    { id: 1, name: 'Sundays', icon: IconBuildingChurch, path: ROUTES.SUNDAY },
    { id: 2, name: 'Fresh Bread', icon: IconBread, path: ROUTES.FRESH_BREAD },
    { id: 3, name: 'Equipping Hour', icon: IconHourglassHigh, path: ROUTES.EQUIPPING_HOUR },
    {
      id: 4,
      name: 'Planning',
      icon: IconClipboardList,
      path: ROUTES.PLANNING,
      capability: 'planServices',
    },
    {
      id: 5,
      name: 'Settings',
      icon: IconSettings,
      path: ROUTES.SETTINGS,
      capability: 'viewSettings',
    },
  ];
}

export type { NavigationItem };
export default NavItems;
